import widgetRegistry, { widgetTypes } from './widgetRegistry';
import { THREE_D_IDS } from './extraVariants';
import VARIANT_LISTS from './variantFamilies';

const CROSSED_FAMILIES = new Set(['gauge', 'chart', 'table']);

function categoryFor(meta, variantId) {
    if (meta.variantFamily === 'gauge') return 'Gauges';
    if (meta.variantFamily === 'chart') return 'Charts';
    if (meta.variantFamily === 'extra') return THREE_D_IDS.includes(variantId) ? '3D Visuals' : 'More Widgets';
    return 'Basic Widgets';
}

function buildCatalog() {
    const entries = [];
    widgetTypes.forEach((meta) => {
        const variants = meta.variantFamily ? VARIANT_LISTS[meta.variantFamily] : null;

        if (variants && variants.length && CROSSED_FAMILIES.has(meta.variantFamily)) {
            entries.push({
                key: meta.type,
                type: meta.type,
                variant: meta.defaultVariant,
                label: meta.label,
                icon: meta.icon,
                category: categoryFor(meta),
                description: meta.description,
                hasStyles: true,
                styleFamily: meta.variantFamily,
            });
        } else if (variants && variants.length) {
            variants.forEach((v) => {
                entries.push({
                    key: `${meta.type}::${v.id}`,
                    type: meta.type,
                    variant: v.id,
                    label: meta.variantFamily === 'extra' ? v.label : `${meta.label} — ${v.label}`,
                    icon: v.icon || meta.icon,
                    category: categoryFor(meta, v.id),
                    description: meta.description,
                });
            });
        } else {
            entries.push({
                key: meta.type,
                type: meta.type,
                variant: undefined,
                label: meta.label,
                icon: meta.icon,
                category: categoryFor(meta),
                description: meta.description,
            });
        }
    });
    return entries;
}

export const WIDGET_CATALOG = buildCatalog();

export const CATALOG_CATEGORY_ORDER = ['Basic Widgets', 'Gauges', 'Charts', 'More Widgets', '3D Visuals'];

export function stylesForType(type) {
    const meta = widgetRegistry[type];
    if (!meta?.variantFamily) return [];
    return VARIANT_LISTS[meta.variantFamily] || [];
}

export function buildPreviewConfig(entry) {
    const meta = widgetRegistry[entry.type];
    return {
        id: `preview-${entry.key}`,
        type: entry.type,
        title: entry.label,
        variant: entry.variant,
        layout: { x: 0, y: 0, w: 4, h: 4, minW: 1, minH: 1 },
        settings: { ...meta.defaultSettings },
        dataSource: { ...meta.defaultDataSource },
    };
}

export function buildStylePreviewConfig(config, variantId) {
    return {
        ...config,
        id: `preview-style-${config.id}-${variantId}`,
        variant: variantId,
    };
}
